export const HOLLOW = 'hollow'
export const GLOW = 'glow'
export const SHADOW = 'shadow'
export const GRADIENT = 'gradient'
export const MAX_INTENSITY = 0.5
